module.exports = __webpack_public_path__ + "img/drh5_icon_weibo.e3afe3a9.png";